import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const accesspackageApiService = createApi({
  reducerPath: "accesspackageApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    checkPrivateAccess: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `accesspackage/check-access${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useCheckPrivateAccessQuery } = accesspackageApiService;
